import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Grid, Typography } from "@mui/material";
import { memo } from "react";
import { StageProps } from "../../../redux/Hire/jobRequestApi";

const SortableItem = ({
  id,
  name,
  mandatory,
  allowDirectTransition,
}: StageProps & { id: string }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id, disabled: mandatory });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Grid
      display={"flex"}
      height={"32px"}
      width={"100%"}
      alignItems={"center"}
      justifyContent={"space-between"}
      bgcolor={"#F0E9FC"}
      item
      ref={setNodeRef}
      style={style}
      px={1}
      {...attributes}
      {...listeners}
    >
      <Grid container item gap={1} xs={11}>
        {!mandatory && <img src={"/images/four-arrow.svg"} alt="" />}
        <Typography fontSize={"16px"} lineHeight={"16px"} fontWeight={500}>
          {name}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default memo(SortableItem);
